import { render } from "./WeatherWidget.vue?vue&type=template&id=0fa5d0f4&scoped=true"
import script from "./WeatherWidget.vue?vue&type=script&lang=js"
export * from "./WeatherWidget.vue?vue&type=script&lang=js"

import "./WeatherWidget.vue?vue&type=style&index=0&id=0fa5d0f4&lang=scss&scoped=true"
import "./WeatherWidget.vue?vue&type=style&index=1&id=0fa5d0f4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa5d0f4"]])

export default __exports__